export default __webpack_public_path__ + "static/logo-fbf1299a12086d4373024b6903819753.jpg";